import { z } from 'zod';

import { BaseLoanEvent } from '../BaseLoanEvent';

export const ReverseLiquidationEvent = BaseLoanEvent.extend({
  type: z.literal('reverseLiquidation'),
});
export type ReverseLiquidationEvent = z.infer<typeof ReverseLiquidationEvent>;
